import { Component, Input } from '@angular/core';
import { AbstractControlComponent } from '@shared/component/form-controls/abstract-control/abstract-control.component';
import { CalendarReminderTypeEnum } from 'taxtank-core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@shared/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { ValidationErrorModule } from '@shared/component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-reminder-type-select',
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    RxReactiveFormsModule,
    TranslateModule,
    ValidationErrorModule,
  ],
  templateUrl: './reminder-type-select.component.html',
  styleUrl: './reminder-type-select.component.scss'
})
export class ReminderTypeSelectComponent extends AbstractControlComponent<number> {
  @Input() hasEmptyOption = false;
  @Input() placeholder = 'Select';
  readonly types = CalendarReminderTypeEnum;
}
